var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKycIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.333984L22.956 2.76865C23.5653 2.90465 24 3.44465 24 4.06998V17.386C24 20.0607 22.6627 22.5593 20.4373 24.042L12 29.6673L3.56267 24.042C1.336 22.558 0 20.0607 0 17.3873V4.06998C0 3.44465 0.434667 2.90465 1.044 2.76865L12 0.333984ZM12 3.06598L2.66667 5.13932V17.386C2.66667 19.1687 3.55733 20.834 5.04133 21.8233L12 26.4633L18.9587 21.8233C20.4427 20.834 21.3333 19.17 21.3333 17.3873V5.13932L12 3.06732V3.06598ZM17.936 9.96332L19.8227 11.8487L11.3373 20.334L5.68 14.6767L7.56533 12.7913L11.336 16.562L17.936 9.96198V9.96332Z",
    fill: "#98A2B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycIcon);
export default __webpack_public_path__ + "static/media/kycIcon.346a776241f954d42d30335beab38fcc.svg";
export { ForwardRef as ReactComponent };